import React, { Component } from "react";
import BootstrapTable from "react-bootstrap-table-next";
import { Form, Button, ButtonGroup, ToggleButtonGroup, ToggleButton, OverlayTrigger, Tooltip, Spinner, } from "react-bootstrap";
import { DailyActivityService } from "../../../../Common/Services/DailyActivity";
import { ReactPageLoader } from "../../../../Common/Components/ReactPageLoader";
import { resolve, reject } from "q";
import { Utils } from "../../../../Common/Utilis";
import { toast } from "react-toastify";
import EllipsisWithTooltip from "react-ellipsis-with-tooltip";
import InputeEllipisWithTooltip from "../../../../Common/Components/InputeEllipisWithTooltip";
import { ISegmentationEntryRequest } from "../../../../Common/Contracts/ISegmentationEntryRequest";

class Segmentation extends Component<any, any> {
  private scrollPos: any;
  constructor(props: any) {
    super(props);
    this.scrollPos = React.createRef();
    this.state = {
      isModified: false,
      rateCodeData: [],
      rateCodeDataCopy: [],
      rateCodeDataFromAPI: [],
      isDataLoading: false,
      isDataSaving: false,
      searchText: "",
      isHideEmptyRows: false,
      defaultToggleBtn: "rate-codes",
      rateCodeSummaryData: [],
      rateCodeSummaryDataCopy: [],
      rateCodeSummaryDataFromAPI: [],
      roomRevenueTotal: 0,
    };
  }

  componentDidMount(): void {
    this.fetchRateCodeData();
    this.getRoomRevenueTotal();
  }

  componentDidUpdate(prevProps) {
    if (
      !this.props.isLoadingDefaultDate &&
      (prevProps.selectedDate !== this.props.selectedDate ||
        prevProps.filterHotelId !== this.props.filterHotelId)
    ) {
      if (this.props.selectedDate) {
        this.setState({ paymentData: [], paymentDataCopy: [], paymentDataFromAPI: [], rateCodeSummaryData: [], rateCodeSummaryDataCopy: [], rateCodeSummaryDataFromAPI: [], isModified: false, searchText: "", isHideEmptyRows: false, });
        this.fetchRateCodeData();
        this.getRoomRevenueTotal();
      } else {
        this.setState({ paymentData: [], paymentDataCopy: [], paymentDataFromAPI: [], rateCodeSummaryData: [], rateCodeSummaryDataCopy: [], rateCodeSummaryDataFromAPI: [], isModified: false, searchText: "", isHideEmptyRows: false, });
      }
    }
  }

  fetchRateCodeData = async () => {
    this.setState({ isDataLoading: true });
    const { filterHotelId, selectedDate } = this.props;
    DailyActivityService.getRateCodeData(filterHotelId, selectedDate)
      .then(async (result: any | null) => {
        if (result !== null) {
          let rateCodeData = Object.assign([], JSON.parse(JSON.stringify(result)));
          rateCodeData = rateCodeData.map((data) => ({ ...data, isEditRoomRevenue: false, isRowModified: false }))
          this.setState({
            rateCodeData, rateCodeDataCopy: rateCodeData, rateCodeDataFromAPI: rateCodeData,
            isDataLoading: false, isModified: false, searchText: "", isHideEmptyRows: false,
            defaultToggleBtn: "rate-codes",
          });
        } else {
          this.setState({ isDataLoading: false });
        }
        resolve();
      })
      .catch((error) => {
        this.setState({ isDataLoading: false });
        Utils.toastError(error?.message, {
          position: toast.POSITION.BOTTOM_RIGHT,
          containerId: "DA_RateCodes",
        });
        reject();
      });
  };

  getRoomRevenueTotal = async () => {
    const { filterHotelId, selectedDate } = this.props;
    DailyActivityService.getRoomRevenueTotal(filterHotelId, selectedDate)
      .then(async (result: any | null) => {
        if (result !== null && result.length > 0) {
          this.setState({ roomRevenueTotal: result[0].total, });
        } else {
        }
        resolve();
      })
      .catch((error) => {
        Utils.toastError(error?.message, {
          position: toast.POSITION.BOTTOM_RIGHT,
          containerId: "DA_RoomRevenueTotal",
        });
        reject();
      });
  };

  fetchRateCodeSummaryData = async () => {
    this.setState({ isDataLoading: true });
    const { filterHotelId, selectedDate } = this.props;
    DailyActivityService.getRateCodeSummaryData(filterHotelId, selectedDate)
      .then(async (result: any | null) => {
        if (result !== null) {
          let rateCodeSummaryData = Object.assign([], JSON.parse(JSON.stringify(result)));
          rateCodeSummaryData = rateCodeSummaryData.map((data) => ({ ...data, isEditRoomRevenue: false, isRowModified: false }))
          this.setState({ rateCodeSummaryData, rateCodeSummaryDataCopy: rateCodeSummaryData, rateCodeSummaryDataFromAPI: rateCodeSummaryData, isDataLoading: false, isModified: false, searchText: "", isHideEmptyRows: false, });
        } else {
          this.setState({ isDataLoading: false });
        }
        resolve();
      })
      .catch((error) => {
        this.setState({ isDataLoading: false });
        Utils.toastError(error?.message, {
          position: toast.POSITION.BOTTOM_RIGHT,
          containerId: "DA_RateCodeSummary",
        });
        reject();
      });
  };

  onRoomRevenueColFocus = (e, rowIndex, row) => {
    let rateCodeData = Object.assign([], JSON.parse(JSON.stringify(this.state.rateCodeData)));
    let index = rateCodeData.findIndex((x) => x.id === row.id);
    if (index >= 0) {
      rateCodeData[index].isEditRoomRevenue = true;
    }
    this.setState({ rateCodeData });
  }

  onRoomRevenueColBlur = (e, rowIndex, row) => {
    let rateCodeData = Object.assign([], JSON.parse(JSON.stringify(this.state.rateCodeData)));
    let rateCodeDataCopy = Object.assign([], JSON.parse(JSON.stringify(this.state.rateCodeDataCopy)));
    let index1 = rateCodeData.findIndex((x) => x.id === row.id);
    let index2 = rateCodeDataCopy.findIndex((x) => x.id === row.id);
    let isInvalidNo = isNaN(e.target.value);
    if(isInvalidNo) {
      if (index1 >= 0) {
        rateCodeData[index1].roomRevenue = "";
      }
      if (index2 >= 0) {
        rateCodeDataCopy[index2].roomRevenue = "";
      }
    }
    if (index1 >= 0) {
      rateCodeData[index1].isEditRoomRevenue = false;
    }
    this.setState({ rateCodeData, rateCodeDataCopy });
  }

  handleInputChange = (e, rowIndex, row, type) => {
    let rateCodeData = Object.assign([], JSON.parse(JSON.stringify(this.state.rateCodeData)));
    let rateCodeDataCopy = Object.assign([], JSON.parse(JSON.stringify(this.state.rateCodeDataCopy)));
    let inputId = "";
    let cursorIndex = -1;
    let index1 = rateCodeData.findIndex((x) => x.id === row.id);
    let index2 = rateCodeDataCopy.findIndex((x) => x.id === row.id);
    if (type === "roomRevenue") {
      inputId = "roomRevenueCol_" + rowIndex;
      cursorIndex = e.target.selectionStart;
      let revenue = Utils.removeInvaildCharFromAmount(e.target.value);
      if (index1 >= 0) {
        rateCodeData[index1].roomRevenue = revenue;
        rateCodeData[index1].isRowModified = true;
      }
      if (index2 >= 0) {
        rateCodeDataCopy[index2].roomRevenue = revenue;
        rateCodeDataCopy[index2].isRowModified = true;
      }
    } else if (type === "roomOccupied") {
      inputId = "roomOccupiedCol_" + rowIndex;
      cursorIndex = e.target.selectionStart;
      let rooms = e.target.value.replace(/[^0-9]/g, '');
      rooms = rooms === "" ? "" : Number(rooms);
      if (index1 >= 0) {
        rateCodeData[index1].roomOccupied = rooms;
        rateCodeData[index1].isRowModified = true;
      }
      if (index2 >= 0) {
        rateCodeDataCopy[index2].roomOccupied = rooms;
        rateCodeDataCopy[index2].isRowModified = true;
      }
    }
    this.setState({ rateCodeData, rateCodeDataCopy, isModified: true }, () => {
      this.props.setCurrentTabStatusOnValuesChanges(true);
      $("#" + inputId).focus().prop("selectionEnd", cursorIndex);
    });
    if (!this.state.isModified) {
      setTimeout(() => {
        let offSetTop = this.scrollPos.current.childNodes[0].childNodes[0].childNodes[1].childNodes[rowIndex].offsetTop - 145;
        this.scrollPos.current?.childNodes[0]?.scrollTo({ top: offSetTop , behavior: 'smooth', });
      }, 50)
    }
  }

  hideEmptyRows = (event) => {
    this.setState({ isHideEmptyRows: event.target.checked }, () => {
      this.filterSegmentationData();
    });
  }

  handleSearch = (event) => {
    this.setState({ searchText: event.target.value }, () => {
      this.filterSegmentationData();
    });
  }

  filterSegmentationData = () => {
    debugger;
    let rateCodeData = Object.assign([], JSON.parse(JSON.stringify(this.state.rateCodeDataCopy)));
    let newRateCodeData: any = [];
    let rateCodeSummaryData = Object.assign([], JSON.parse(JSON.stringify(this.state.rateCodeSummaryDataCopy)));
    let newRateCodeSummaryData: any = [];
    let searchedValue = this.state.searchText;

    if (searchedValue.length > 0 && this.state.defaultToggleBtn === "rate-codes") {
      rateCodeData = rateCodeData.filter((row) => {
        return (
          row.rateCode?.toString().toLowerCase().includes(searchedValue.toLowerCase()) ||
          row.rateName?.toLowerCase().includes(searchedValue.toLowerCase()) ||
          row.description?.toString().toLowerCase().includes(searchedValue.toLowerCase()) ||
          row.roomOccupied?.toString().toLowerCase().includes(searchedValue.toLowerCase()) ||
          row.roomRevenue?.toString().toLowerCase().includes(searchedValue.toLowerCase()) ||
          (row.roomRevenue === null || row.roomRevenue === "" ? false : Utils.currencyFormatWithOutdoller(row.roomRevenue)?.toString().toLowerCase().includes(searchedValue.toLowerCase()))
        )
      });
    }

    if (searchedValue.length > 0 && this.state.defaultToggleBtn === "summary") {
      rateCodeSummaryData = rateCodeSummaryData.filter((row) => {
        return (
          row.itemName?.toString().toLowerCase().includes(searchedValue.toLowerCase()) ||
          row.description?.toString().toLowerCase().includes(searchedValue.toLowerCase()) ||
          row.total?.toString().toLowerCase().includes(searchedValue.toLowerCase()) ||
          row.roomRevenueTotal?.toString().toLowerCase().includes(searchedValue.toLowerCase()) ||
          (row.roomRevenueTotal === null || row.roomRevenueTotal === "" ? false : Utils.currencyFormatWithOutdoller(row.roomRevenueTotal)?.toString().toLowerCase().includes(searchedValue.toLowerCase()))
        )
      });
    }

    newRateCodeData = Object.assign([], JSON.parse(JSON.stringify(rateCodeData)));
    newRateCodeSummaryData = Object.assign([], JSON.parse(JSON.stringify(rateCodeSummaryData)));

    if (this.state.isHideEmptyRows && this.state.defaultToggleBtn === "rate-codes") {
      newRateCodeData = [];
      for (let i = 0; i < rateCodeData.length; i++) {
        if ((rateCodeData[i].roomOccupied !== null && rateCodeData[i].roomOccupied !== "") || (rateCodeData[i].roomRevenue !== null && rateCodeData[i].roomRevenue !== "")) {
          newRateCodeData.push(rateCodeData[i]);
        }
      }
    }
    this.setState({ rateCodeData: newRateCodeData, rateCodeSummaryData: newRateCodeSummaryData, });
  }

  handleDiscard = () => {
    let rateCodeData = Object.assign([], JSON.parse(JSON.stringify(this.state.rateCodeDataFromAPI)));
    let rateCodeSummaryData = Object.assign([], JSON.parse(JSON.stringify(this.state.rateCodeSummaryDataFromAPI)));
    this.props.setCurrentTabStatusOnValuesChanges(false);
    this.setState({ rateCodeData, rateCodeDataCopy: rateCodeData, rateCodeSummaryData, rateCodeSummaryDataCopy: rateCodeSummaryData, isModified: false, searchText: "", isHideEmptyRows: false, });
  }

  toggleEntrySwitch = (event: any) => {
    this.setState({ defaultToggleBtn: event }, () => {
      this.onToggleBtnChange();
    });
  }

  onToggleBtnChange = () => {
    if (this.state.defaultToggleBtn === "rate-codes") {
      this.fetchRateCodeData();
    } else {
      this.fetchRateCodeSummaryData();
    }
  }

  handleSave = async () => {
    const { rateCodeDataCopy }: any = this.state;
    const { filterHotelId, selectedDate } = this.props;

    const modifiedRows = rateCodeDataCopy.filter((row) => row.isRowModified);

    if (modifiedRows.length === 0) {
      toast.info("No changes to save.");
      return;
    }
    this.setState({ isDataSaving: true });
    const payload: ISegmentationEntryRequest[] = modifiedRows.map((entry) => ({
      BackHid: filterHotelId,
      Date: selectedDate,
      ID: entry?.id,
      RateCode: entry?.rateCode,
      RateName: entry?.rateName,
      RoomOccupied: entry?.roomOccupied,
      RoomRevenue: entry?.roomRevenue,
      Status: "",
      OldStatus: "",
      RateCodeID: "",
      Hid: "",
      Adjustment: entry?.adjustment,
      Explanation: "",
      Total: 0,
      RoomRevenueTotal: 0,
      UserToken: "",
    }));

    try {
      debugger;
      const response: any = await DailyActivityService.saveSegmentationData(
        payload
      );
      const { failedCount, failedEntries } = response;

      if (failedCount > 0) {
        if (failedEntries[0]?.errorMessage !== "" && failedEntries[0]?.errorMessage !== undefined && failedEntries[0]?.errorMessage !== null ){
          toast.error(failedEntries[0]?.errorMessage);
        } else {
          toast.error(`${failedCount} entries failed to save.`);
        }
      } else {
        toast.success("Data saved successfully!");
      }
      this.props.setCurrentTabStatusOnValuesChanges(false);
      this.setState({ isModified: false, searchText: "", isHideEmptyRows: false, });
      this.fetchRateCodeData();
      this.props.refreshMainData();
    } catch (error) {
      toast.error("Failed to insert segmentation entry.");
      console.error("Insert error:", error);
    } finally {
      this.setState({ isDataSaving: false });
    }
  };

  render() {
    const borderFormatter = (column, colIndex) => {
      return (
        <>{column.text}<div className="border-bottom"></div></>
      );
    }
    const borderFooterFormatter = (column, colIndex, { text })=>{
      return (
        <>
          <div className="border-top"></div>
          <div className="border-bottom"></div>
        </>
      );
    }
    const columns = [{
      dataField: 'rateCode',
      text: 'Rate Code',
      headerClasses: 'width-150',
      headerFormatter: borderFormatter,
      footer: (columnData, column) => {
        if (this.state.searchText.length > 0 || this.state.rateCodeData.length === 0) {
          return "";
        }
        return (
          <>
            <div>
              <ul>
                <li className="lable">Segmentation Totals</li>
                <li className="lable">Revenue Totals</li>
              </ul>
              <div className="lable">Variance</div>
            </div>
            <div className="border-top"></div>
            <div className="border-bottom"></div>
          </>
        )
      },
    }, {
      dataField: 'rateName',
      text: 'Rate Name',
      headerFormatter: borderFormatter,
      footerFormatter: borderFooterFormatter,
      footer: '',
    }, {
      dataField: "description",
      text: "Description",
      headerClasses: "notes-width",
      headerFormatter: borderFormatter,
      footerFormatter: borderFooterFormatter,
      formatter: (cell, row, rowIndex) => (
        <EllipsisWithTooltip placement="bottom">{row.description === null ? "" : row.description}</EllipsisWithTooltip>
      ),
      footer: '',
    }, {
      dataField: 'roomOccupied',
      text: 'Rooms Occupied',
      headerClasses: 'align-right width-140',
      classes: 'align-right',
      headerFormatter: borderFormatter,
      formatter: (cell: any, row: any, rowIndex: any) => (
        <Form.Control
          id={"roomOccupiedCol_" + rowIndex}
          type="text"
          className="width-124 text-right"
          value={row.roomOccupied === null || row.roomOccupied === "" ? "" : row.roomOccupied}
          onChange={(e: any) => this.handleInputChange(e, rowIndex, row, "roomOccupied")}
          maxLength={5}
          autoComplete='off'
        />
      ),
      footer: (columnData, column) => {
        if (this.state.searchText.length > 0 || this.state.rateCodeData.length === 0) {
          return "";
        }
        let sum = columnData.reduce((acc, item) => Number(acc) + Number(item === null ? 0 : item), 0);
        return (
          <>
            <div className="value">{sum}</div>
            <div className="border-top"></div>
            <div className="border-bottom"></div>
          </>
        )
      },
      footerAlign: (column, colIndex) => 'right',
    }, {
      dataField: "roomRevenue",
      text: 'Room Revenue',
      headerClasses: 'align-right width-140',
      classes: 'align-right',
      headerFormatter: borderFormatter,
      formatter: (cell: any, row: any, rowIndex: any) => (
        // <InputeEllipisWithTooltip placement="bottom" inputeVal={row.roomRevenue === null || row.roomRevenue === "" ? "" : Utils.currencyFormatWithOutdoller(row.roomRevenue)}>
          <Form.Control type="text"
            id={"roomRevenueCol_" + rowIndex}
            value={row.roomRevenue === null || row.roomRevenue === "" ? "" : row?.isEditRoomRevenue ? row.roomRevenue : Utils.currencyFormatWithOutdoller(row.roomRevenue)}
            className="width-124 text-right"
            onChange={(e: any) => this.handleInputChange(e, rowIndex, row, "roomRevenue")}
            onBlur={e => this.onRoomRevenueColBlur(e, rowIndex, row)}
            onFocus={e => this.onRoomRevenueColFocus(e, rowIndex, row)}
            autoComplete='off'
          />
        // </InputeEllipisWithTooltip>
      ),
      footer: (columnData, column) => {
        if (this.state.searchText.length > 0 || this.state.rateCodeData.length === 0) {
          return "";
        }
        let sum = columnData.reduce((acc, item) => Number(acc) + Number(item === null ? 0 : item), 0);
        let variance = sum - this.state.roomRevenueTotal;
        return (
          <>
            <div>
              <ul>
                <li className="value">{Utils.currencyFormat(sum)}</li>
                <li className="value">{Utils.currencyFormat(this.state.roomRevenueTotal)}</li>
              </ul>
              <div className={`value upperborder ${variance !== 0 ? "red" : ""}`}>{Utils.currencyFormat(variance)}</div>
            </div>
            <div className="border-top"></div>
            <div className="border-bottom"></div>
          </>
        )
      },
      footerAlign: (column, colIndex) => 'right',
    }];

    const summaryColumns = [{
      dataField: 'itemName',
      text: 'Segment Name',
      headerFormatter: borderFormatter,
      formatter: (cell, row, rowIndex) => (
        <EllipsisWithTooltip placement="bottom">{row.itemName === null ? "" : row.itemName}</EllipsisWithTooltip>
      ),
      footer: (columnData, column) => {
        if (this.state.searchText.length > 0 || this.state.rateCodeSummaryData.length === 0) {
          return "";
        }
        return (
          <>
            <div>
              <ul>
                <li className="lable">Segmentation Totals</li>
                <li className="lable">Revenue Totals</li>
              </ul>
              <div className="lable">Variance</div>
            </div>
            <div className="border-top"></div>
            <div className="border-bottom"></div>
          </>
        )
      },
    }, {
      dataField: "description",
      text: "Description",
      headerClasses: "notes-width",
      headerFormatter: borderFormatter,
      footerFormatter: borderFooterFormatter,
      formatter: (cell, row, rowIndex) => (
        <EllipsisWithTooltip placement="bottom">{row.description === null ? "" : row.description}</EllipsisWithTooltip>
      ),
      footer: '',
    }, {
      dataField: 'total',
      text: 'Rooms Occupied',
      headerClasses: 'align-right width-150',
      classes: 'align-right',
      headerFormatter: borderFormatter,
      formatter: (cell: any, row: any, rowIndex: any) => (
        <EllipsisWithTooltip placement="bottom">{row.total === null || row.total === "" ? "" : row.total}</EllipsisWithTooltip>
      ),
      footer: (columnData, column) => {
        if (this.state.searchText.length > 0 || this.state.rateCodeSummaryData.length === 0) {
          return "";
        }
        let sum = columnData.reduce((acc, item) => Number(acc) + Number(item === null ? 0 : item), 0);
        return (
          <>
            <div className="value">{sum}</div>
            <div className="border-top"></div>
            <div className="border-bottom"></div>
          </>
        )
      },
      footerAlign: (column, colIndex) => 'right',
    }, {
      dataField: "roomRevenueTotal",
      text: 'Room Revenue',
      headerClasses: 'align-right width-150',
      classes: 'align-right',
      headerFormatter: borderFormatter,
      formatter: (cell: any, row: any, rowIndex: any) => (
        <EllipsisWithTooltip placement="bottom">{row.roomRevenueTotal === null || row.roomRevenueTotal === "" ? "" : Utils.currencyFormatWithOutdoller(row.roomRevenueTotal)}</EllipsisWithTooltip>
      ),
      footer: (columnData, column) => {
        if (this.state.searchText.length > 0 || this.state.rateCodeSummaryData.length === 0) {
          return "";
        }
        let sum = columnData.reduce((acc, item) => Number(acc) + Number(item === null ? 0 : item), 0);
        let variance = sum - this.state.roomRevenueTotal;
        return (
          <>
            <div>
              <ul>
                <li className="value">{Utils.currencyFormat(sum)}</li>
                <li className="value">{Utils.currencyFormat(this.state.roomRevenueTotal)}</li>
              </ul>
              <div className={`value upperborder ${variance !== 0 ? "red" : ""}`}>{Utils.currencyFormat(variance)}</div>
            </div>
            <div className="border-top"></div>
            <div className="border-bottom"></div>
          </>
        )
      },
      footerAlign: (column, colIndex) => 'right',
    }];

    return (
      this.state.isDataLoading ? (
        <ReactPageLoader useas={"revenue-nonrevenue"} />
      ) : (
        <div className='payment-section reuse-sub-design'>

          <div className='filter-section d-flex'>
            <div className="toggle-button-group margin-right-24">
              <ButtonGroup aria-label="Basic example">
                <ToggleButtonGroup
                  type="radio"
                  name="options"
                  defaultValue={this.state.defaultToggleBtn}
                  onChange={this.toggleEntrySwitch}
                  className="d-flex align-items-center">
                  <ToggleButton value={"rate-codes"} disabled={this.state.isModified} className="d-flex align-items-center">Rate Codes</ToggleButton>
                  <ToggleButton value={"summary"} disabled={this.state.isModified} className="d-flex align-items-center">Summary</ToggleButton>
                </ToggleButtonGroup>
              </ButtonGroup>
            </div>
            <div className='search-input sec'>
              <Form.Control type="text" placeholder="Search" value={this.state.searchText} onChange={(e) => this.handleSearch(e)} />
            </div>
            {this.state.defaultToggleBtn === "rate-codes" &&
              <div className='ml-auto'>
                <div className='togglebtn d-flex align-items-center'>
                  <div className='label'>Hide Empty Rows</div>
                  <Form.Check
                    id="hide-empty-row-payments"
                    type="switch"
                    checked={this.state.isHideEmptyRows}
                    onChange={this.hideEmptyRows}
                  />
                </div>
              </div>
            }
          </div>

          {this.state.defaultToggleBtn === "rate-codes" &&
            <div ref={this.scrollPos} className={`body-section tbl-footer ${this.state.isModified ? "footer-exist" : ""} ${this.state.searchText.length > 0 || this.state.rateCodeData.length === 0 ? "filter-val" : ""}`}>
              <BootstrapTable
                keyField="id"
                data={this.state.rateCodeData}
                columns={columns}
                noDataIndication="No data found"
              />
            </div>
          }

          {this.state.defaultToggleBtn === "summary" &&
            <div className={`body-section tbl-footer ${this.state.isModified ? "footer-exist" : ""} ${this.state.searchText.length > 0 || this.state.rateCodeSummaryData.length === 0 ? "filter-val" : ""}`}>
              <BootstrapTable
                keyField="itemUniqueNo"
                data={this.state.rateCodeSummaryData}
                columns={summaryColumns}
                noDataIndication="No data found"
              />
            </div>
          }

          {this.state.isModified &&
            <div className='footer-section d-flex align-items-center'>
              <div className='msg'>You have unsaved changes</div>
              <div className='ml-auto action'>
                <Button variant="primary" type="button" className="space btn btn-primary btn-discard" disabled={this.state.isDataSaving} onClick={() => this.handleDiscard()}>Discard</Button>
                <Button variant="primary" type="button" className="btn btn-primary" disabled={this.state.isDataSaving} onClick={() => this.handleSave()}>Save Changes</Button>
              </div>
            </div>
          }

          {this.state.isDataSaving && (
            <div className="loader-spinner d-flex justify-content-center align-items-center">
              <Spinner animation="border" variant="success" />
            </div>
          )}
        </div>
      )
    );
  }
}

export default Segmentation;
